<template>
  <!-- <div class="centerContainer1"> -->
  <div class="allBox flex">
    <div class="leftBox">
      <div class="leftTop">
        <div class="flex">
          <img :src="userInfo.avatar" style="width:.92rem;height: .92rem;border-radius:50%;" />
          <div class="flex" style="flex-wrap: wrap;">
            <div class="ownName w100 ">{{userInfo.nickName}}</div>
            <div class="ownZhi w100 ">职称：<span v-if="teacherInfo">{{teacherInfo.title || '无'}}</span><span v-else>无</span></div>
            <!-- <div class="ownNum w100 ">第<>15</ span>次登录</div> -->
          </div>
        </div>
        <div class="danwei">单位：<span v-if="teacherInfo">{{teacherInfo.schoolName || '无'}}</span>
          <span v-else>无</span></div>
      </div>
      <div class="leftBottom">
        <div @click="toRight(item,index)" :class="menuIndex == index?'menuList active':'menuList'"
          v-for="(item,index) in menuData" :key="index" v-show="item.show == true">
          <span :class="'icon '+item.icon"></span>
          <span class="menuMing">{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class="rightBox">
      <router-view></router-view>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
  import { getInfo, getTeacherInfo, logout } from '@/api/login'
  import { getToken } from '@/utils/auth'
  export default {
    name: 'leftMenu',
    
    props: {
      menuIndex: {
        type: Number,
        default: 0
      },
      menuData: {
        type: Array,
        default: ()=> {
          return []
        }
      },
    },
    data() {
      return {
        userInfo: '',
        teacherInfo:{},
        schoolInfo:{},
        isManage:sessionStorage.getItem('isManage'),
        isAudit:sessionStorage.getItem('isAudit')
      };
    },
    created() {
      if(getToken()) {} else {
        this.$store.commit("LoginFun", true);
      }
      this.getUserInfo();
    },
    methods: {
      getUserInfo() {
        getInfo().then(response => {
          if(!response.user.avatar){
            response.user.avatar = require('@/assets/images/defaultavatar.png')
          }
          this.userInfo = response.user
          if(response.user.userId != 1){
            getTeacherInfo(response.user.userId).then(res => {
              this.teacherInfo = res.data.teacher
              this.schoolInfo = res.data.school
              if(res.data.isManage){
                sessionStorage.setItem("isManage", res.data.isManage);
              }else{
                sessionStorage.removeItem('isManage')
              }
              if(res.data.isAudit){
                sessionStorage.setItem("isAudit", res.data.isAudit);
              }else{
                sessionStorage.removeItem('isAudit')
              }
              // for(var i=0;i<this.menuData.length;i++){
              //   if(this.menuData[i].name == '我的审核'){
              //     if(sessionStorage.getItem('isManage') == true || sessionStorage.getItem('isManage') == 'true' || sessionStorage.getItem('isAudit') == true || sessionStorage.getItem('isAudit') == 'true'){
              //       this.menuData[i].show = true
              //     }else if((sessionStorage.getItem('isManage') == false || sessionStorage.getItem('isManage') == 'false') && (sessionStorage.getItem('isAudit') == false || sessionStorage.getItem('isAudit') == 'false') ){
              //       this.menuData[i].show = false
              //     }else if(!res.data.isManage || !res.data.isManage){
              //       this.menuData[i].show = true
              //     }
              //   }
              // }
            })
          }
        });
      },
      toRight(item, index) {
        console.log(item)
        this.$router.push({
          path: item.link
        });
      },
    },
  };
</script>
<style scoped>
  .centerContainer1 {
    margin-top: .7rem;
    position: relative;
  }

  .allBox {
    min-height: 8rem;
    justify-content: space-between;
    margin: .2rem 0px;
  }

  .leftBox {
    width: 14%;
    background: #fafafa;
  }

  .leftTop {
    background: #FAF2E5;
    padding: .16rem;
  }

  .leftTop .ownName {
    font-size: .14rem;
    color: #e97b44;
    padding-left: .12rem;
    padding-top: .08rem;
  }

  .leftTop .ownZhi {
    font-size: .12rem;
    color: #8f8f8f;
    padding-left: .12rem;
  }

  .leftTop .ownZhi span {
    font-size: .12rem;
    color: #000;
  }

  .leftTop .ownNum {
    font-size: .12rem;
    color: #000;
    padding-left: .12rem;
  }

  .leftTop .ownNum span {
    font-size: .12rem;
    color: #2698e7;
    padding: 0px .04rem;
  }

  .leftTop .danwei {
    font-size: .12rem;
    color: #8f8f8f;
    padding-top: .12rem;
  }

  .leftTop .danwei span {
    font-size: .12rem;
    color: #000;
  }

  .leftBottom {
    padding: .08rem .16rem;
  }

  .leftBottom .menuList {
    line-height: .36rem;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .leftBottom .menuList:hover {
    background: rgb(230, 93, 34, 0.08);
  }

  .leftBottom .menuList.active {
    background: rgb(230, 93, 34, 0.08);
  }

  .leftBottom .menuList span {
    color: #656565;
    font-size: .14rem;
  }

  .leftBottom .menuList .icon {
    font-size: .18rem;
    padding-left: .14rem;
    padding-right: .06rem;
  }

  .leftBottom .active span {
    color: #e65d22;
  }

  .leftBottom .menuList:hover span {
    color: #e65d22;
  }

  .rightBox {
    position: relative;
    width: 82%;
  }
</style>


// WEBPACK FOOTER //
// src/nav/study/components/leftMenu.vue